import React from 'react';
import Navbar from '../components/Navbar';
import Pricing from '../components/Pricing';
import FreeTrialBanner from '../components/FreeTrialBanner';
import FAQ from '../components/FAQ';
import { CTASection, Footer } from '../components/FooterCTA';
import useReveal from '../hooks/useReveal';
import useCMS from '../hooks/useCMS';

export default function PricingPage() {
  useReveal();
  const { cms } = useCMS();

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="bg-pastel-hero">
          <Pricing cms={cms?.pricing} />
        </div>
        <FreeTrialBanner />
        <FAQ cms={cms?.faq} />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
